import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { h5PageCount } from 'ThreeTerminal_utils';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';

class TvFeed extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        moduleName: PropTypes.string,
        isVideoShare: PropTypes.bool,
    };

    callAppHandle = (data, isSendCount = true, isJumpQQlink = false, isCallAppWx = true) => {
        const { moduleName } = this.props;
        const callAppKind = moduleName === 'tvTheater' ? 'share52208' : 'share52209';
        const pageCountType = moduleName === 'tvTheater' ? 'phmoviehot' : 'phmovietopic';
        const callAppUrl = `https://phtv.ifeng.com/loc/tvTheater/details/${data.id}?ref=&isFull=0&immersion=true&backindex=true`;
        const callAppDownload =
            moduleName === 'tvTheater'
                ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1526325085897'
                : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1526325324255';
        const callAppDownloadAd =
            moduleName === 'tvTheater'
                ? 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8981'
                : 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8982';

        if (isSendCount) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: pageCountType,
                    other: {
                        id: data.id,
                        url: encodeURIComponent(location.href),
                    },
                },
            ]);
        }

        if (isCallAppWx) {
            callApp({
                docType: 'web',
                pid: callAppUrl,
                kind: callAppKind,
                download: callAppDownload,
                downloadAd: callAppDownloadAd,
                isJumpQQlink,
            });
        }
    };

    render() {
        const { content, moduleName, isVideoShare } = this.props;

        return content.map((item, index) => {
            const schemeLink = getSchemeLink({
                docType: 'web',
                pid: `https://phtv.ifeng.com/loc/tvTheater/details/${item.id}?ref=&isFull=0&immersion=true&backindex=true`,
                kind: moduleName === 'tvTheater' ? 'share52208' : 'share52209',
            });

            return (
                <div
                    onClick={() => {
                        this.callAppHandle(item);
                    }}
                    key={index}
                    className={`${styles.videoItem} ${moduleName === 'tvTheater' ? styles.videoRow : ''}`}>
                    <div className={styles.imagePart}>
                        <LazyImg className={styles.imagePartPic} src={formatImageWebpAuto(item.thumbnail, 226, 304)} />
                        <span className={styles.collect} />
                        {item.tag && <span className={styles.tag}>{item.tag}</span>}
                        {item.dataTotal && <div className={styles.nums}>全{item.dataTotal}集</div>}
                    </div>
                    <div className={styles.title}>{item.title}</div>
                    {/* <div className={styles.subTitle}>{item.summary}</div> */}
                    {!isVideoShare && (
                        <WxLaunchApp
                            launchType="app"
                            launchAppClick={this.callAppHandle.bind(this, item, true, false, false)}
                            schemeLink={schemeLink}
                            launchAppFail={this.callAppHandle.bind(this, item, false, true, true)}
                        />
                    )}
                </div>
            );
        });
    }
}

export default errorBoundary(TvFeed);
